export const getExceededPaymentV2Transactions = `
  query($page: Int!) {
    getExceededPaymentV2Transactions(page: $page) {
      totalFailedCount
      totalQueueCount
      totalLess12QueueCount
      totalLess24QueueCount
      totalLess48QueueCount
      totalMore48QueueCount
      transactions {
        transactionId
        errorCode
        errorMessage
        chargeType
        client
        failCount 
      }
    }
  }
`;

export interface ITransaction {
  transactionId: string;
  errorCode: string;
  errorMessage: string;
  chargeType: string;
  client: string;
  failCount: number;
}

export interface IQueueTransactionSummary {
  totalQueueCount: number;
  totalLess12QueueCount: number;
  totalLess24QueueCount: number;
  totalLess48QueueCount: number;
  totalMore48QueueCount: number;
}

interface ITransactionSummary extends IQueueTransactionSummary {
  totalFailedCount: number;
  transactions: ITransaction[];
}

export interface IGetPaymentV2FailedTransactionResult {
  getExceededPaymentV2Transactions: ITransactionSummary;
}
